import { useState } from 'react';
import { PROJECTS, PROJECT_FILTERS } from '../../database/database';
import { Project } from '../../models/project';
import style from './portfolio.module.css';

function PortfolioItem({ project }: { project: Project }) {
  return (
    <div className={style.portfolioItem} key={project.id}>
      <a href={project.url} target="_blank" rel="noreferrer">
        <img src={project.cover} alt={project.name} loading="lazy" />
        <h3>{project.name}</h3>
      </a>
      <p>{project.description}</p>
    </div>
  );
}

export default function Portfolio() {
  const [projects, setProjects] = useState(PROJECTS);
  const [activeFilter, setFilter] = useState(1);

  const filterProjects = (filter: number) => {
    setFilter(filter);
    if (filter === 1) {
      setProjects(PROJECTS);
      return;
    }
    setProjects(PROJECTS.filter((project) => project.tag.includes(filter)));
  };

  return (
    <div className={style.portfolio} id="portfolio">
      <h2>Portfolio</h2>
      <p>A Collection of My Recent Works</p>
      <div className={style.filters}>
        {PROJECT_FILTERS.map((filter) => {
          return (
            <p
              className={
                activeFilter === filter.value ? style.activeFilter : ''
              }
              key={filter.value}
              onClick={() => filterProjects(filter.value)}
            >
              {filter.label}
            </p>
          );
        })}
      </div>
      <div className={style.portfolio_container}>
        {projects.map((project) => (
          <PortfolioItem key={project.id} project={project} />
        ))}
      </div>
    </div>
  );
}
